import { Injectable } from '@angular/core';
import { IID_OLOPOPSVLAN } from '@common/interfaces/interfaceData';
import { AbstractInterfaceDataQuery } from '../interfaceDataModel';
import { IIDolVlanStore } from './iidOlVlan.store';
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({ providedIn: 'root' })
@InterfaceDataQuery(InterfaceName.IID_OLO_POP_SVLAN)
export class IIDolVlanQuery extends AbstractInterfaceDataQuery<IID_OLOPOPSVLAN> {
  constructor(protected store: IIDolVlanStore) {
    super(store);
  }
}
